// extracted by mini-css-extract-plugin
module.exports = {"eventsTitle":"styles_eventsTitle__1ZYwJ","gridContainer":"styles_gridContainer__1R9G0"};